import { useIsOnSemanticSearch } from '@hooks/use-is-on-semantic-search';
import { useAppSelector } from '@redux/hooks';
import { useAtomValue } from 'jotai';
import { useEffect } from 'react';
import { appliedFiltersFormattedAtom } from '../containers/FilterPills/atoms';
import { orderRecentlySeenDirectories } from '../helpers/recentlySearchedDirectories';

const getSemanticSearchFromUrl = (): string | null => {
	if (typeof window === 'undefined') return null;

	const urlParams = new URLSearchParams(window.location.search);
	const query = urlParams.get('q');

	// Return the query if it exists and is not empty
	return query && query.trim().length > 0 ? query.trim() : null;
};

export const useOrderRecentlySeenDirectories = () => {
	// Use individual selectors to avoid creating new object references on every render
	const marketCode = useAppSelector((state) => state.search.marketCode);
	const category = useAppSelector((state) => state.category);
	const city = useAppSelector((state) => state.location.city);
	const stateCode = useAppSelector((state) => state.location.stateCode);
	const appliedFiltersFormatted = useAtomValue(appliedFiltersFormattedAtom);
	const { isOnSemanticSearch } = useIsOnSemanticSearch();

	// Record the search when page loads or when URL-based search parameters change
	// Read the semantic search directly from URL query parameters to avoid typing results
	useEffect(() => {
		const semanticSearchQuery = isOnSemanticSearch
			? getSemanticSearchFromUrl()
			: null;

		orderRecentlySeenDirectories({
			marketCode,
			category: category.code,
			city,
			stateCode,
			appliedFilterPills: appliedFiltersFormatted,
			semanticSearch: semanticSearchQuery,
		});
	}, [
		marketCode,
		category.code,
		city,
		stateCode,
		appliedFiltersFormatted,
		isOnSemanticSearch,
	]);
};
